
import * as api from '~/api/index';
export default {
  data() {
    return {
      type: 0,
      arr: [],
    };
  },
  async fetch() {
    const $axios = this.$nuxt.$axios;
    const [dayChartResult, weekChartResult] = await Promise.all([
      $axios(api.getHotArticle('dayChart')).catch(() => ({})),
      $axios(api.getHotArticle('weekChart')).catch(() => ({})),
    ]);
    this.arr = [dayChartResult?.result ?? [], weekChartResult?.result ?? []];
  },
  fetchKey: 'weekChart-dayChart',
  fetchOnServer: true,
};
